export const getChannelSlug = (): string | null => {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script?.src) return null;

  try {
    return new URL(script.src).searchParams.get("channel");
  } catch {
    return null;
  }
};